<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">

                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >
                    {{ $t('common.add') }}
                </el-button>
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >
                    修改
                </el-button>
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >
                    {{ $t('common.delete') }}
                </el-button>
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill') }}</el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item label="ID：">
                                <el-input v-model="form.id" disabled></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item label="业务时间:" required>
                                <el-date-picker
                                    type="datetime"
                                    :disabled="isedit"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期"
                                    v-model="form.bill_date"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item label="产品：" required>
                                <mySelect
                                    v-model="form.style_no"
                                    :options="allArr.style"
                                    values="style_no"
                                    labels="style_name"
                                    keys="style_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item label="熔后重量：">
                                <el-input
                                    type="number"
                                    @change="handleChangeMeltWgt"
                                    v-model="form.melt_wgt"
                                    :disabled="isedit">
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.handler') + '：'">
                                <mySelect
                                    v-model="form.staff_no"
                                    :options="allArr.staff"
                                    values="staff_no"
                                    labels="staff_name"
                                    keys="staff_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="input_col">
                            <el-form-item :label="$t('common.remark') + '：'">
                                <el-input
                                    type="textarea"
                                    :rows="1"
                                    v-model="form.remark"
                                    :disabled="isedit">
                                </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 结价数据表格 -->
        <el-dialog title="结价明细" :visible.sync="dialogTableVisible" width="80%">
            <div class="big_box">
                <div class="header_warpper">
                    <div class="left">
                        <el-form
                            :model="quotedForm"
                            :rules="computedRules"
                            ref="ruleForm"
                            label-position="top"
                            :inline="true"
                            style="display: flex; justify-content: space-between"
                        >
                            <template v-for="(item, index) in quotedCondition.item">
                                <el-form-item
                                    :prop="item.ismust == 1 ? item.item_no : null"
                                    :label="item.item_name"
                                    style=""
                                    :key="index"
                                    v-if="(item.type == 'select' || item.type == 'select-multiple') && item.status == 1"
                                >
                                    <el-select
                                        size="mini"
                                        v-model="quotedForm[item.item_no]"
                                        filterable
                                        clearable
                                        @clear="handleClear(item)"
                                        :multiple="item.type == 'select-multiple'"
                                        default-first-option
                                        :placeholder="'请选择' + item.item_name"
                                        style="width: 100%"
                                    >
                                        <el-option
                                            v-for="option in quotedCondition.value[item.item_no.replace('_no', '')] || []"
                                            :key="option[item.item_no.replace('_no', '') + '_no']"
                                            :label="`${option[item.item_no.replace('_no', '') + '_no']} - ${
                                        option[item.item_no.replace('_no', '') + '_name']
                                    }`"
                                            :value="option[item.item_no.replace('_no', '') + '_no']"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item
                                    :prop="item.ismust == 1 ? item.item_no : null"
                                    :label="item.item_name"
                                    style=""
                                    :key="index"
                                    v-else-if="(item.type == 'number' || item.type == 'text') && item.status == 1"
                                >
                                    <el-input
                                        v-model="quotedForm[item.item_no]"
                                        :type="item.type"
                                        :placeholder="'请输入' + item.item_name"
                                        style="width: 100%"
                                    ></el-input>
                                </el-form-item>
                                <el-form-item
                                    :prop="item.ismust == 1 ? item.item_no : null"
                                    :label="item.item_name"
                                    v-else-if="item.type == 'switch' && item.status == 1"
                                    :key="index"
                                    style=""
                                >
                                    <el-tag
                                        :type="quotedForm[item.item_no] == '1' ? 'success' : quotedForm[item.item_no] == '0' ? 'danger' : ''">
                                        {{
                                            quotedForm[item.item_no] == 1 ? '是' : '否'
                                        }}
                                    </el-tag>
                                    <el-switch style="margin-left: 5px" v-model="quotedForm[item.item_no]"
                                               :active-value="1" :inactive-value="0">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item
                                    :prop="item.ismust == 1 ? item.item_no : null"
                                    :key="index"
                                    :label="item.item_name"
                                    style=""
                                    v-else-if="item.status == 1 && ['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)"
                                >
                                    <el-date-picker
                                        v-bind="getDatePickerProps(item)"
                                        v-model="quotedForm[item.item_no]"
                                    />
                                </el-form-item>
                            </template>
                        </el-form>
                    </div>
                    <div class="right">
                        <!-- <el-button @click="freshen">{{ $t('common.refresh') }}</el-button> -->
                        <el-button @click="getQuotedData" type="primary" plain class="action_button">{{ $t('common.search') }}</el-button>
                    </div>
                </div>
                <template>
                    <div class="selectTableBox">
                        <el-table
                            border
                            height="500"
                            :data="quotedData.data"
                            style="width: 100%; margin-top: 5px; font-size: 14px"
                            row-key="seq"
                            @selection-change="handleSelectionChange"
                            ref="elTable"
                        >
                            <!-- 添加 checkbox 列 -->
                            <el-table-column
                                type="selection"
                                width="50"
                                align="center"
                            >
                            </el-table-column>
                            <template slot="empty">
                                <div style="display: flex; justify-content: center; align-items: center; height: 700px">
                                    <img src="@/assets/img/dontHave.png" alt="" style="width: 250px; height: 250px" />
                                </div>
                            </template>

                            <el-table-column
                                v-for="(item, index) in quotedData.head"
                                :key="index"
                                :prop="item.field"
                                :label="item.title"
                                :width="item.field == 'seq' ? 50 : 160"
                                :align="item.field == 'seq' ? 'center' : 'left'"
                                :sortable="item.issort == 1"
                                v-if="item.status == 1"
                                :sort-method="(a, b) => a[item.field] - b[item.field]"
                            >
                                <!-- 使用 v-slot 定义插槽内容 -->
                                <template v-slot="scope">
                                    <!-- 针对 bill_no 列的特殊渲染 -->
                                    <div v-if="item.field == 'bill_no'">
                                        <el-button type="text" @click="handleDetails(scope.row)">
                                            {{ scope.row.bill_no }}
                                        </el-button>
                                    </div>
                                    <!-- 默认渲染其他列 -->
                                    <div v-else>
                                        {{ scope.row[item.field] }}
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                background
                                layout="total, sizes, prev, pager, next, jumper"
                                :current-page="quotedForm.page"
                                :page-size="quotedForm.page_size"
                                :page-sizes="[100, 200, 300, quotedPageTotal]"
                                :total="quotedPageTotal"
                                @current-change="handlePageChange"
                                @size-change="page_sizeChange"
                            ></el-pagination>
                            <div>
                                <el-button @click="usedQuotedData" type="success" plain class="action_button">确认
                                </el-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </el-dialog>
        <!-- 表格 -->
        <div class="table1" @mouseleave="dtlleave">
            <div class="title">
                <p>{{ $t('common.productDetail') }}</p>
                <el-button type="primary" @click=showDialogTable() :disabled="isedit">结价数据</el-button>

            </div>
            <vxe-table
                border
                stripe
                resizable
                keep-source
                align="center"
                ref="xTable1"
                :height="maxHeight"
                show-overflow
                highlight-hover-row
                :loading="loading"
                show-footer-overflow
                :footer-method="footerMethod"
                show-footer
                :keyboard-config="{ isArrow: true, isDel: true, isedit: true }"
                :row-class-name="rowChange"
                :data="form.dtl"
                :mouse-config="{ selected: true }"
                :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                @cell-mouseenter="dtlenter"
                :key="refushTable"
                :scroll-y="{ enabled: true, gt: 50 }"
                :tooltip-config="{}"
            >
                <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                <vxe-table-column type="seq" field="seq" width="70" title="序号">
                    <template slot="header">
                        <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                    </template>
                    <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
<!--                            <i class="el-icon-circle-plus-outline" @click="adddtl"></i>-->
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                        <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                    </template>
                </vxe-table-column>

                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                        v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select'
                        "
                    >
                        <template v-slot:edit="{ row }">
                            <vxe-input
                                type="text"
                                @input="handleInput(row, item.field, item.column_type)"
                                @keydown.native="jumptable($event, row, item.field)"
                                v-model="row[item.field]"
                                @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                :disabled="item.column_disabled == 1"
                            ></vxe-input>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column
                        v-if="item.column_status == 1 && item.column_type == 'select'"
                        :title="item.column_name"
                        :field="item.field"
                        :width="item.column_width"
                        :key="item.field + index"
                        :edit-render="{ autofocus: '.el-input__inner' }"
                    >
                        <template #default="{ row }">
                            <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                        </template>
                        <template v-slot:edit="{ row }">
                            <el-select
                                size="mini"
                                v-model="row[item.field]"
                                ref="stylefocus"
                                filterable
                                default-first-option
                                placeholder="请选择"
                                @change="changeData(row, item.field.replace('_no', ''))"
                                @keydown.native="jumptable($event, row, item.field)"
                                :disabled="item.column_disabled == 1"
                            >
                                <el-option
                                    v-for="option in allArr[item.field.replace('_no', '')] || []"
                                    :key="option[item.field.replace('_no', '') + '_no']"
                                    :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                    :value="option[item.field.replace('_no', '') + '_no']"
                                    :disabled="option.status == 0"
                                ></el-option>
                            </el-select>
                        </template>
                    </vxe-table-column>
                </template>

                <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                </template>
            </vxe-table>
        </div>
        <!-- 页脚 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.totalWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item label="熔损重量：">
                        <p>{{ form.loss_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="平均单价：">
                        <p>{{ form.avg_prc }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.totalAmt') + '：'">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}</el-button>
            </div>
        </div>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    apiGetMetalAvgPrcCountData,
    apiGetMetalAvgPrcCountPull,
    apiGetMetalAvgPrcCountQuotedPull,
    apiModifyMetalAvgPrcCountData,
    apiAddMetalAvgPrcCountData,
    apiDelMetalAvgPrcCountData,
    apiCheckMetalAvgPrcCount,
    apiCurrentPermisson,
    apiSystem,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiGetMetalAvgPrcCountQuotedDate
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'MetalAvgPrcCount',
    data() {
        return {
            //引用数据表格
            dialogTableVisible: false,
            quotedCondition: [],
            selectedRows: [],
            selectedRowKeys: [], // 用于存储所有选中的行的唯一标识
            quotedData: {
                data: [], // 当前页的数据
                head: []  // 表头信息
            },
            quotedPageTotal: 0,
            quotedForm: {
                page: 1,
                page_size: 100,
                billDateRange: []
            },


            TotalAmt: 0,
            TotalWgt: 0,
            AvgPrc: 0,
            allArr: '',
            form: { remark: '' },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 480,
            headers: {},
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '126',
            perData: {}, //权限
            rowSeq: 0,
            reader: null, // 声明为组件属性
            port: null, // 声明为组件属性
            query: {}
        };
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getPullData();
        this.getTable();
        this.getPermission();
        document.addEventListener('keydown', (event) => {
            if (event.key === 'F9') {
                this.getValue();
            } else {
                this.mykeyup(event);
            }
        });
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // if (this.$route.query.isadd == 0) {
        //     this.add();
        // } else {
        //     this.geData();
        // }
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    computed: {
        // 动态计算表单验证规则
        computedRules() {
            const rules = {};
            // 遍历 quotedCondition.item，根据 ismust 为 1 的项来动态生成验证规则
            if (this.quotedCondition.item) {
                this.quotedCondition.item.forEach((item) => {
                    // console.log(item, 'item有值没有啊');
                    if (item.ismust == 1) {
                        if (['date', 'datetime', 'daterange', 'datetimerange'].includes(item.type)) {
                            rules[item.item_no] = [{
                                required: true,
                                message: `请选择${item.item_name}`,
                                trigger: 'change'
                            }];
                        } else if (['select', 'switch'].includes(item.type)) {
                            rules[item.item_no] = [{
                                required: true,
                                message: `请选择${item.item_name}`,
                                trigger: 'change'
                            }];
                        } else {
                            rules[item.item_no] = [
                                {
                                    required: true,
                                    message: `${item.item_name}不能为空`,
                                    trigger: 'blur'
                                }
                            ];
                        }
                    }
                });
            }

            return rules;
        }
    },
    methods: {
        //================引用数据begin======================
        showDialogTable() {
            if (this.form.style_no == '') {
                this.$message.error('请先选择产品！');
                return;
            }
            this.dialogTableVisible = true;
        },
        handleClear(item) {
            // console.log('Cleared:', item.item_no);
            // 清空后的逻辑
            this.quotedForm[item.item_no] = ''; // 或者其他适当的处理方式
        },
        handleDetails(row) {
            if (row.allow_use == '0') {
                this.$message.error('暂无权限');
            } else {
                if (row.bill_code) {
                    this.$router.push({
                        path: '/' + row.bill_code,
                        query: {
                            bill_no: row.bill_no
                        }
                    });
                }
            }
        },
        handleSelectionChange(selection) {
            // 提取当前页选中行的唯一标识（假设每行都有一个唯一的 seq 字段）
            const currentPageSelectedKeys = selection.map(row => row.seq);

            // 合并当前页的选中行到全局选中行集合中（去重）
            this.selectedRowKeys = [
                ...new Set([...this.selectedRowKeys, ...currentPageSelectedKeys])
            ];

            // 将当前页选中的行数据也存储到 selectedRows 中（去重）
            const newSelectedRows = selection.filter(row =>
                !this.selectedRows.some(selectedRow => selectedRow.seq === row.seq)
            );
            this.selectedRows = [...this.selectedRows, ...newSelectedRows];
        },
        usedQuotedData() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }

            // 直接使用 selectedRows 中的数据
            // this.form.dtl = this.selectedRows; // 使用所有选中的行数据
            this.form.dtl = this.selectedRows.map(row => ({
                bill_no: row.bill_no,
                billtype_no: row.billtype_no,
                bill_date: row.bill_date,
                cust_no: row.cust_no,
                style_no: row.style_no,
                wgt: row.wgt,
                wgt_prc: row.wgt_prc,
                amt: row.amt
            }));
            // this.selectedRowKeys = []; // 清空选中行记录
            // this.selectedRows = []; // 清空选中行数据
            this.dialogTableVisible = false; // 关闭弹窗
        },
        getQuotedData() {
            this.quotedForm.style = this.form.style_no;
            let data = this.quotedForm;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$load.show();
                    apiGetMetalAvgPrcCountQuotedDate(data).then((res) => {
                        if (res.code == 2000) {
                            this.quotedData = res.data;
                            this.quotedPageTotal = res.data.count;

                            // 恢复当前页的选中状态
                            this.$nextTick(() => {
                                if (this.$refs.elTable) { // 确保 elTable 引用存在
                                    const currentPageRows = this.quotedData.data;
                                    currentPageRows.forEach(row => {
                                        if (this.selectedRowKeys.includes(row.seq)) {
                                            this.$refs.elTable.toggleRowSelection(row, true);
                                        }
                                    });
                                }
                            });

                            this.$message.success(res.msg);
                            this.$load.close();
                        } else {
                            this.quotedData = [];
                            this.quotedPageTotal = 0;
                            this.$message.error(res.data.info);
                            this.$load.close();
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getDatePickerProps(item) {
            const baseProps = {
                style: 'width: 99%',
                placeholder: '选择' + item.item_name
            };
            switch (item.type) {
                case 'date':
                    return {
                        ...baseProps,
                        type: 'date',
                        valueFormat: 'yyyy-MM-dd'
                    };
                case 'datetime':
                    return {
                        ...baseProps,
                        type: 'datetime',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss'
                    };
                case 'daterange':
                    return {
                        ...baseProps,
                        type: 'daterange',
                        valueFormat: 'yyyy-MM-dd',
                        startPlaceholder: '开始日期',
                        endPlaceholder: '结束日期',
                        defaultTime: ['00:00:00', '23:59:59'],
                        pickerOptions: this.pickerOptions
                    };
                case 'datetimerange':
                    return {
                        ...baseProps,
                        type: 'datetimerange',
                        valueFormat: 'yyyy-MM-dd HH:mm:ss',
                        startPlaceholder: '开始日期',
                        endPlaceholder: '结束日期',
                        defaultTime: ['00:00:00', '23:59:59'],
                        pickerOptions: this.pickerOptions
                    };
                default:
                    return {};
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.quotedForm.page = val;
            this.getQuotedData();
        },
        page_sizeChange(val) {
            this.quotedForm.page = 1;
            this.quotedForm.page_size = val;
            this.getQuotedData();
        },
        //================引用数据end========================
        handleChangeMeltWgt() {
            const lossWgt = (this.TotalWgt - this.form.melt_wgt).toFixed(this.systemSet.wgt);
            this.form.loss_wgt = lossWgt;

            const avgPrc = this.form.melt_wgt && parseFloat(this.form.melt_wgt) !== 0
                ? (parseFloat(this.TotalAmt) / parseFloat(this.form.melt_wgt)).toFixed(this.systemSet.amt)
                : '0.00'; // 若分母为 0 或无效，则默认返回 0.00
            this.AvgPrc = avgPrc;
            this.form.avg_prc = avgPrc;

        },
        handleInput(row, field, type) {
            // 如果不是数字类型，直接返回
            if (type !== 'number') return;

            // 获取当前输入值
            let inputValue = row[field];

            // 如果输入值为空或不是字符串，设置为空字符串
            if (inputValue === null || inputValue === undefined) {
                row[field] = '';
                return;
            }

            // 转换为字符串处理
            inputValue = String(inputValue);

            // 保留数字、小数点和负号
            let cleanedValue = inputValue.replace(/[^0-9.-]/g, '');

            // 只保留第一个小数点
            const decimalIndex = cleanedValue.indexOf('.');
            if (decimalIndex !== -1) {
                cleanedValue = cleanedValue.substring(0, decimalIndex + 1) + cleanedValue.substring(decimalIndex + 1).replace(/\./g, '');
            }

            // 处理负号：只允许在开头有一个负号
            let negativeSign = '';
            if (cleanedValue.startsWith('-')) {
                negativeSign = '-';
                cleanedValue = cleanedValue.substring(1);
            }

            // 去掉中间或末尾的负号
            cleanedValue = cleanedValue.replace(/-/g, '');

            // 如果只有小数点，转换为 0.
            if (cleanedValue === '.') {
                cleanedValue = '0.';
            }

            // 合并负号和处理后的值
            row[field] = negativeSign + cleanedValue;
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/MetalAvgPrcCount') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },

        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiGetMetalAvgPrcCountData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    this.last = info.last;
                    this.first = info.first;
                    this.maxHeight = 480;
                    if (res.data.data.dtl.length > 4) {
                        let length = res.data.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                } else {
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            });
            this.$load.close();
        },
        // 获取下拉框信息---------------------------------------
        getPullData() {
            apiGetMetalAvgPrcCountPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
            apiGetMetalAvgPrcCountQuotedPull({}).then((res) => {
                if (res.code == 2000) {
                    this.quotedCondition = res.data;
                    this.quotedData.head = res.data.head;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },

        changeData(row, type) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            // 找到索引
            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo);

            if (idx !== -1) {
                // 取出相应的信息
                const info = arrayToSearch[idx];

                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.form = { dtl: [] };
            this.type = '4';
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/MetalAvgPrcCount');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            this.isSave = true;
            if (this.isedit == true) {
                if (this.form.check == 0) {
                    this.isedit = false;
                    if (this.form.dtl.length == 0) {
                        this.insertEvent(-1);
                    }
                } else if (this.form.check == 1) {
                    this.isCheck = true;
                }
            }
        },
        // 保存修改------------------------------------------
        saveItSub() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.form;
                var table1 = this.$refs.xTable1.getTableData().fullData;
                data['dtl'] = table1;
                data['check'] = this.form.check == true ? '1' : '0';
                this.$load.show();
                if (this.isAdd == true) {
                    apiAddMetalAvgPrcCountData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功');
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.isAdd = false;
                            this.isedit = true;
                            this.selectedRowKeys = []; // 清空选中行记录
                            this.selectedRows = []; // 清空选中行数据
                            this.quotedData = [];
                            this.quotedPageTotal = 0;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/MetalAvgPrcCount');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiModifyMetalAvgPrcCountData(data).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            this.last = info.last;
                            this.first = info.first;
                            this.isedit = true;
                            this.selectedRowKeys = []; // 清空选中行记录
                            this.selectedRows = []; // 清空选中行数据
                            this.quotedData = [];
                            this.quotedPageTotal = 0;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
            }
        },
        //新建单据-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '' };
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;

                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                // setTimeout(() => {
                //     for (let i = 0; i < 3; i++) {
                //         this.insertEvent(-1);
                //     }
                // }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
        },
        //删除单据-----------------------------------------
        delOrder() {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                apiDelMetalAvgPrcCountData({
                    id: this.form.id
                }).then((res) => {
                    if (res.code == 2000) {
                        this.$message({ message: '删除成功', type: 'success' });
                        if (res.data.data == null) {
                            this.form = {};
                            this.nullBtn = true;
                        } else {
                            this.form = res.data.data;
                            if (this.form.check == 1) {
                                this.isCheck = true;
                            } else {
                                this.isCheck = false;
                            }
                        }
                        this.last = res.data.last;
                        this.first = res.data.first;
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });

        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiCheckMetalAvgPrcCount({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        //页码切换:上一单、下一单、第一单、最后一单
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/MetalAvgPrcCount' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },
        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
            // this.$refs.stylefocus.focus();
        },
        // 不可编辑-------------------------------------
        activeRowMethod(row) {
            if (row.seq) {
                this.rowSeq = row.seq;
                //console.log(this.rowSeq, 'this.rowSeq');
            } else {
                ++this.rowSeq;
            }
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },

        // 表尾合计---------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.TotalWgt = this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt);
                        this.$set(this.form, 'sumwgt', this.TotalWgt);

                        const lossWgt = (this.TotalWgt - this.form.melt_wgt).toFixed(this.systemSet.wgt);
                        this.$set(this.form, 'loss_wgt', lossWgt);

                        const avgPrc = this.form.melt_wgt && parseFloat(this.form.melt_wgt) !== 0
                            ? (parseFloat(this.TotalAmt) / parseFloat(this.form.melt_wgt)).toFixed(this.systemSet.amt)
                            : '0.00'; // 若分母为 0 或无效，则默认返回 0.00
                        this.AvgPrc = avgPrc;
                        this.$set(this.form, 'avg_prc', this.AvgPrc);

                        return `${this.TotalWgt} `;
                    } else if (column.property == 'amt') {
                        this.TotalAmt = this.$utils.sum(data, column.property).toFixed(this.systemSet.amt);
                        this.$set(this.form, 'sumamt', this.TotalAmt);

                        const avgPrc = this.form.melt_wgt && parseFloat(this.form.melt_wgt) !== 0
                            ? (parseFloat(this.TotalAmt) / parseFloat(this.form.melt_wgt)).toFixed(this.systemSet.amt)
                            : '0.00'; // 若分母为 0 或无效，则默认返回 0.00
                        this.AvgPrc = avgPrc;
                        this.$set(this.form, 'avg_prc', this.AvgPrc);

                        return `${this.TotalAmt} `;
                    } else {
                        return '-';
                    }
                })
            ];
        },

        //列配置相关接口begin-----------------
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '126';
            }
            this.drawers = true;
        },

        checkMove() {
        },

        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        getTable() {
            apiGetListCorrespondingData({
                id: '126'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        //列配置相关接口end-----------------


        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '202'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },

        adddtl() {
            // this.insertEvent(-1);
            // let length = this.$refs.xTable1.getTableData().fullData.length;
            // if (length > 4 && length < 11) {
            //     this.maxHeight += 48;
            // }
        },
        deldtl(scoped) {
            let length = this.$refs.xTable1.getTableData().fullData.length;
            this.$refs.xTable1.remove(scoped.row);
            if (length == 1) {
                this.adddtl();
            }
        },
        goHistory() {
            this.$router.push({ path: '/MetalAvgPrcCountHistory', query: { page: 'MetalAvgPrcCount' } });
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().tableColumn;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;
            //问题1：回车键最后一条不需要输入的列处理
            //问题2：无法确定一个有几个需要跳过的列
            var addnum = 1; //跳过列的基本参数，每一个需要跳过的加1
            var addnumleft = 1;
            if (column[columnIndex + 1]) {
                if (column[columnIndex + 1].className == 'jump') {
                    let newColumn = column.slice(columnIndex + 1);
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnum += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }
            if (column[columnIndex - 1]) {
                if (column[columnIndex - 1].className == 'jump') {
                    let newColumn = column.slice(0, columnIndex).reverse();
                    try {
                        newColumn.forEach((item) => {
                            if (item.className == 'jump') {
                                addnumleft += 1;
                            } else {
                                throw new Error();
                            }
                        });
                    } catch (error) {
                    }
                }
            }
            // 右移;
            var jumpnum = columnIndex + addnum;
            if (column[jumpnum]) {
                var downtype = column[jumpnum].property;
            }
            // 左移
            var jumpnumleft = columnIndex - addnumleft;
            if (column[jumpnumleft]) {
                var uptype = column[jumpnumleft].property;
            }
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().fullData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode === row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (allowBreak) {
                        // 跳转到下一列
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }
        }
    }
};

// 添加一个 LineBreakTransformer 类
class LineBreakTransformer {
    constructor() {
        this.chunks = '';
    }

    transform(chunk, controller) {
        this.chunks += chunk;
        const lines = this.chunks.split('\r\n');
        this.chunks = lines.pop();
        lines.forEach((line) => controller.enqueue(line));
    }

    flush(controller) {
        controller.enqueue(this.chunks);
    }
}
</script>

<style scoped>
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    height: 50px;

    .left {
        display: flex;
        align-items: center;
    }
}

.footer {
    height: 56px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 150px;
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}

.pagination {
    display: flex;
    justify-content: space-between; // 让分页器和按钮分别位于左右两侧
    align-items: center; // 垂直居中对齐
    .action_button {
        margin-left: 20px; // 可选：增加按钮与分页器之间的间距
    }
}

</style>
